import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'fun-calendar-pay-overview',
  templateUrl: './calendar-pay-overview.component.html',
  styleUrls: ['./calendar-pay-overview.component.scss'],
})
export class CalendarPayOverviewComponent implements OnInit {

  @Input() calendarBenefits: any;
  @Input() isInvestor: boolean;

  benefitsByMonth = [];
  fullBenefits = [];

  text = this.translate.instant('PAYMENT_CALENDAR.NO_PAY');
  image = 12;

  mode: string;

  constructor(private utils: UtilsService, private translate: TranslateService) { }

  ngOnInit() {
    this.mode = 'list';
    for (let i = 0; i < this.calendarBenefits.length; i++) {
      for (let j = 0; j < this.calendarBenefits[i].benefits.length; j++) {
        this.calendarBenefits[i].benefits[j]['month'] = this.utils.parseMonthShort(this.calendarBenefits[i].date[1]);
        this.calendarBenefits[i].benefits[j]['day'] = this.calendarBenefits[i].date[2];
      }
    }
    if (this.isInvestor === false) {
      this.text = this.translate.instant('PAYMENT_CALENDAR.NO_PAY_NO_INVESTOR');
    }
  }

  changeMode(mode: string) {
    this.mode = mode;
  }

}
